import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import format from 'date-fns/format';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

import { FlightInfoSegmentInfo_segment$key } from '__generated__/FlightInfoSegmentInfo_segment.graphql';
import Typography from '@mui/material/Typography';

type Props = {
  segment: FlightInfoSegmentInfo_segment$key;
};

const FlightInfoSegmentInfo: FC<Props> = ({ segment }) => {
  const { supplier, flightNumber, departDatetime, arrivalDatetime } =
    useFragment(
      graphql`
        fragment FlightInfoSegmentInfo_segment on FlightSegment {
          supplier
          flightNumber
          departDatetime
          arrivalDatetime
        }
      `,
      segment
    );

  const departDate = format(new Date(departDatetime), 'yyyy-MM-dd');
  const arrivalDate = format(new Date(arrivalDatetime), 'yyyy-MM-dd');

  return (
    <Box sx={{ mt: 1, fontSize: '.9em' }}>
      <Box>
        {departDate !== arrivalDate ? (
          <Grid container>
            <Grid item xs={5}>
              <Typography variant="caption">{departDate}</Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography variant="caption">{arrivalDate}</Typography>
            </Grid>
          </Grid>
        ) : (
          <Typography variant="caption">{departDate}</Typography>
        )}
      </Box>

      <Box sx={{ paddingTop: '15px', textAlign: 'right' }}>
        <Typography variant="caption">
          {supplier} {flightNumber}
        </Typography>
      </Box>
    </Box>
  );
};

export default FlightInfoSegmentInfo;
